import { render, staticRenderFns } from "./compAdd.vue?vue&type=template&id=62bde635&scoped=true"
import script from "./compAdd.vue?vue&type=script&lang=js"
export * from "./compAdd.vue?vue&type=script&lang=js"
import style0 from "./compAdd.vue?vue&type=style&index=0&id=62bde635&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bde635",
  null
  
)

export default component.exports